import { useEffect, useState } from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@react-google-maps/api";
import { PROPERTY_TYPE_URL } from "../../Global/API's";

const Banner = () => {
  const [filteredValue, setFilteredValue] = useState({
    searchValue: "",
    propertyType: [],
  });
  const [searchResult, setSearchResult] = useState("");
  const [propertyTypeData, setPropertyTypeData] = useState(null);
  const navigate = useNavigate();

  const onDataSubmit = () => {
    navigate(
      `/buy?propertyType=${filteredValue.propertyType}&search=${searchResult}`,
      {
        state: {
          filteredValue,
          isTrue: true,
        },
      }
    );
  };

  const getPropetyTypeData = async () => {
    const response = await fetch(PROPERTY_TYPE_URL);
    const fetchedData = await response.json();
    const filterData = fetchedData.data
      .split(",")
      .filter((item) => item !== "");
    setPropertyTypeData(filterData);
  };

  useEffect(() => {
    getPropetyTypeData();
  }, []);

  return (
    <section className="banner">
      <div className="item">
        <div className="container">
          <div className="banner-block">
            <h1>
              Find your Home with <br />
              Selzer realty & Associates
            </h1>
          </div>
          <div className="Search-block">
            <form>
              <div className="form-group">
                <label>Location</label>
                <input
                  type="seacrh"
                  className="form-control"
                  placeholder="Enter Location"
                  onChange={(e) => setSearchResult(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Property Type</label>
                <select
                  onChange={(e) => {
                    setFilteredValue({
                      ...filteredValue,
                      propertyType: [e.target.value],
                    });
                  }}
                  defaultValue="0"
                  className="form-control"
                >
                  <option value="0" disabled>
                    Any
                  </option>
                  {propertyTypeData &&
                    propertyTypeData.map((item, index) => (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    ))}
                </select>
              </div>
              <button className="btn" onClick={onDataSubmit} type="submit">
                <i className="fa fa-search" aria-hidden="true"></i> Search
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Banner;
